import styled from "styled-components";

export const S_Button = styled.button`
  outline: none;
  border: none;
  background: none;
  
  & {
    cursor: pointer;
  }
`;